// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-unlocked"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.999 16.5H22.999V21H15.999V16.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 20H2V3.5H9L11 6H22V9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.25 16.5V14.75C17.25 13.5074 18.2574 12.5 19.5 12.5C20.1188 12.5 20.6793 12.7498 21.0861 13.1541M15.999 16.5H22.999V21H15.999V16.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderUnlockedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-unlocked',
    ref,
    icon: element,
  },
));

FolderUnlockedIcon.displayName = 'FolderUnlockedIcon';

export default FolderUnlockedIcon;
